import {AUTHORITIES} from "./Constants";

/**
 * Autoridades das rotas de destino dos atalhos da Visão Diária. A mesma lista
 * protege a rota (ProtectedRoute) e decide a visibilidade do atalho.
 */
export const DASHBOARD_OVERVIEW_ROUTE_AUTHORITIES = {
    ALARMS: [AUTHORITIES.SYSADMIN, AUTHORITIES.VIEW_DASHBOARD, AUTHORITIES.VIEW_DASHBOARD_ALARM],
    SYNOPTIC: [AUTHORITIES.SYSADMIN, AUTHORITIES.VIEW_DASHBOARD, AUTHORITIES.VIEW_DASHBOARD_SYNOPTIC],
    PERFORMANCE: [AUTHORITIES.SYSADMIN, AUTHORITIES.VIEW_DASHBOARD, AUTHORITIES.VIEW_DASHBOARD_PERFORMANCE],
    UNAVAILABILITY: [AUTHORITIES.SYSADMIN, AUTHORITIES.MANAGE_UNAVAILABILITY],
};
